/** Payment routes use the same case and trailing-slash behavior as React Router. */
function normalizedPath(value: string) {
  try {
    return decodeURIComponent(value).replace(/\/+$/, "").toLowerCase() || "/";
  } catch {
    return value.toLowerCase();
  }
}
export function isPaymentLocation(
  location: Pick<Location, "pathname" | "search">,
) {
  const pathname = normalizedPath(location.pathname);
  // Authorization identifiers and the signing handoff are private too.
  if (pathname === "/.lovable/oauth/consent") return true;
  if (/^\/pagos-programados(?:\/|$)/.test(pathname)) return true;
  if (pathname === "/login") {
    const next = new URLSearchParams(location.search).get("next");
    if (next) {
      try {
        const target = new URL(next, "https://payment.invalid");
        return target.origin === "https://payment.invalid" &&
          (/^\/pagos-programados(?:\/|$)/.test(normalizedPath(target.pathname)) ||
            normalizedPath(target.pathname) === "/.lovable/oauth/consent");
      } catch {
        return false;
      }
    }
  }
  return false;
}
